import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import tmsService from '../../services/axios/tmsService';
import clientService from '../../services/axios/axiosService';
import qs from 'qs';
import VueScrollTo from 'vue-scrollto';
import googleAutoComplete from '../../services/googleAPI/autoComplete';
import { Validator } from 'vee-validate';

import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
// helper classes
import QuoteRequestBuilder from './quoteRequestBuilder';
import QuoteResultAnalyzer from './quoteResultAnalyzer';
import QuoteMapper from './quoteMapper';
import switchBillingToService from '../../shared/switchBillingToService';

// Components
import template from './unis100Quote.vue';
import ShippingDetail from '../../components/shippingDetailUnis100';
import EstimatedQuote from '../../components/estimatedQuoteUnis100';
import DefaultModal from '../../components/modal';
import MainButtonSet from '../../components/mainButtonSet';
import Datepicker from 'vuejs-datepicker';
import OneButtonModal from '../../components/oneButtonModal';
import MessageModal from '../../components/messageModel';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import { watch } from 'fs';
import isStateMatchPostcode from '../../validation/validateLocation/isStateMatchPostcode';

@Component({
    mixins: [template],
    components: {
        ShippingDetail,
        Datepicker,
        EstimatedQuote,
        DefaultModal,
        MainButtonSet,
        OneButtonModal,
        MessageModal,
    },
})
export default class GetQuoteToUnis100 extends Vue {
    // Data
    quoteData = this.$store.getters.quoteData;
    accessorialData = [];
    tmsAccList: Array<Object> = [];
    warehouseList = [];
    currentWarehouseId: number = 0;
    additionalServiceCodeList: Array<Object> = [];

    hasQuote: boolean = this.$store.getters.quoteData.hasQuote;
    myAccountData: any = this.$store.getters.myAccountData;
    calculating: boolean = false;
    creditLimit: number = 0;
    billToId: any = '';

    isEditMode: boolean = false;
    skipGetQuotePage: boolean = false;
    accArray = [
        'ACC-10007',
        'ACC-10008',
        'ACC-10009',
        'ACC-10010',
        'ACC-10011',
        'ACC-10012',
        'ACC-10013',
        'ACC-10014',
        'ACC-10015',
        'ACC-10016',
        'ACC-10017',
        'ACC-10018',
        'ACC-10019',
        'ACC-10020',
        'ACC-10021',
        'ACC-10022',
    ];

    // Error Modal
    errorNoCreditModal: string = 'getQuoteError';
    errorWidth: number = 423;
    errorNoCreditModalTitle: string = 'Error';
    closeNoCreditErrorModal() {
        this.$modal.hide(this.errorNoCreditModal);
    }
    errorOverCreditModal: string = 'getOverCreditError';
    errorOverCreditModalTitle: string = 'Error';
    closeOverCreditErrorModal() {
        this.$modal.hide(this.errorOverCreditModal);
    }
    showXBtn: boolean = false;

    tooltipMessages: any = {
        wherePickup:
            'To make things easier for you, we default the shipping location to the address connected with your account. Feel free to change the address if you are shipping from a different location.',
        liftGate:
            'We can provide a lifting or lowering device to get your shipment onto our trucks for an additional fee.',
        limitedAccess:
            'Some locations are not easily accessible to the public during business hours and will incur an additional fee. Some examples include:<br/>' +
            '1. churches<br/>' +
            '2. commercial establishments not open to the walk-in public during normal business hours<br/>' +
            '3. construction sites<br/>' +
            '4. fairs, carnivals, etc.<br/>' +
            '5. individual (mini) storage units<br/>' +
            '6. military bases or installations<br/>' +
            '7. schools<br/>',
        palletJack:
            'For locations that do not have a forklift, we will need a pallet jack to move your shipments onto and off our trucks for an additional fee.',
        hazardousMaterial:
            'Does your shipment contain commodities that are hazardous as defined in the code of Federal Regulation, Title 49, by the US Department of Transportation? If so, you will be charged an additional fee and one of our representatives will contact you to get more information about the contents of the shipment.',
    };

    keepQuote: boolean = false;

    validationStarted: boolean = true;
    // Data

    @Inject() $validator: Validator;

    productList = [];

    clickShipperRadio(type: string) {
        if (type === 'terminal') {
            this.currentWarehouseId = 0;
        }
        if (type === 'zipcode') {
            this.quoteData.pickup.city = '';
            this.quoteData.pickup.state = '';
            this.quoteData.pickup.zipCode = '';
        }
    }
    // computed properties
    get palletSpaces() {
        let sum = 0;
        this.quoteData.pallets.forEach((item: any) => {
            sum += parseInt(item.palletSpace);
        });
        this.quoteData.palletSpaces = sum;
        return sum;
    }

    get allTotalWeight() {
        let sum = 0;
        this.quoteData.pallets.forEach((item: any) => {
            sum += parseInt(item.totalWeight);
        });
        return sum;
    }

    get totalPallets() {
        let sum = 0;
        this.quoteData.pallets.forEach((item: any) => {
            sum += parseInt(item.quantity);
        });
        return sum;
    }

    get pageTitle() {
        if (this.quoteData.quoteId) {
            return `Last Mile Quote # ${this.quoteData.quoteId} `;
        } else {
            return 'Last Mile Quote';
        }
    }

    get rightBtnText() {
        if (this.isEditMode) {
            return 'Update Quote';
        } else {
            return 'Get Quote';
        }
    }

    get exceedPalletSpaces() {
        return this.palletSpaces > 15;
    }

    get overWeight() {
        let result = false;

        this.quoteData.pallets.forEach((item: any) => {
            if (item.overWeight) {
                result = item.overWeight;
            }
        });

        return result;
    }
    // end of computed properties

    // life cycle methods
    beforeCreate() {
        this.$store.dispatch('changeQuotePageStage', 'quoteStartPage');

        this.$store.dispatch('resetQuote');
        this.$store.dispatch('resetSchedule');
        this.$store.dispatch('resetEstimate');
    }

    getTmsAccList() {
        let _this = this;
        tmsServiceBackend
            .get(`/quote/getTmsAccList?billto_id=${this.billToId}`)
            .then(function(response) {
                _this.tmsAccList = Object.values(response.data.data);
            });
    }

    async getCustomerData() {
        if (this.skipGetQuotePage) {
            switchBillingToService
                .post()
                .then((res: any) => {
                    if (res.data.billing == null) {
                    } else {
                        this.billToId = res.data.billing.location_id;
                        let billto_id = res.data.billing.location_id;
                        this.getTmsAccList();
                        console.log('billto_id' + billto_id);
                        console.log('total: ' + this.quoteData.estimate.total);
                        let url1 = 'write_new/get_tms_quote_line.php';

                        let json3 = {
                            input_search_quote_id: null,
                            input_search_date_from: null,
                            input_search_date_to: null,
                            billto_id: billto_id,
                            input_search_shipper_state: 'CA',
                            input_search_shipper_zip: null,
                            input_search_consignee_state: 'CA',
                            input_search_consignee_zip: null,
                            input_search_status: 1,
                            input_search_limit: 50,
                            quote: 1,
                            UserID: localStorage.UserID,
                            UserToken: localStorage.UserToken,
                        };

                        tmsService
                            .post(url1, qs.stringify(json3))
                            .then(res => {
                                console.log('res.data.filter: ');
                                console.log(res.data);

                                let c_amount = 0;

                                for (let x in res.data) {
                                    if (res.data[x].tms_quote_id == this.quoteData.quoteId) {
                                        console.log('found: ' + res.data[x].total_amount);
                                        c_amount = res.data[x].total_amount;
                                        break;
                                    }
                                }

                                let bill_to = { billto_id: billto_id, current_amount: c_amount };

                                this.getCreditLimitV2(bill_to);
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    created() {
        this.$validator.extend('stateMatchPostcode', {
            validate: isStateMatchPostcode,
            getMessage: (field: string, params: any, data: any) => {
                return data.message;
            },
        });
        let query = this.$route.query;

        let quoteNumber: any = query.quoteNumber;
        this.quoteData.quoteId = quoteNumber;

        this.isEditMode = query.isEdit ? true : false;
        this.skipGetQuotePage = query.skipGetQuotePage ? true : false;

        let schedule = query.schedule;

        if (!quoteNumber && !this.isEditMode && !schedule) {
            this.quoteData.hasQuote = false;

            // add one line of default pallet to array
            this.quoteData.pallets.push(this.quoteData.getPallet());
        }

        if (parseInt(quoteNumber) > 0) {
            this.getQuote(quoteNumber);
        }

        if (this.isEditMode) {
            this.quoteData.hasQuote = false;
            this.keepQuote = true;
        }

        if (schedule) {
            this.quoteData.hasQuote = true;
            this.keepQuote = true;
        }
        this.$store.dispatch('getMyAccountData');
        // this.$store.dispatch("getLocationData");
        this.getCustomerData();

        this.getWarehouseList();
    }

    @Watch('quoteData.hasQuote')
    @Watch('calculating')
    @Watch('isEditMode')
    zipCodeAutoComplete() {
        console.log(
            'watch hasQuote, calculating, isEditMode',
            this.quoteData.hasQuote,
            this.calculating,
            this.isEditMode
        );
        if (!this.quoteData.hasQuote && !this.calculating) {
            this.$nextTick(() => {
                this.pickupZipAutoComplete();
                this.deliveryZipAutoComplete();
            });
        }
    }

    getWarehouseList() {
        let _this = this;
        let dataString = '?company_id=' + localStorage.company_id;
        tmsServiceBackend.get('/warehouse/getWarehouseList' + dataString).then(function(response) {
            _this.warehouseList = response.data.data;
        });
    }

    mounted() {
        // set up autocomplete for zip code
        this.pickupZipAutoComplete();
        this.deliveryZipAutoComplete();

        // set up event listener for socket result, need to remove when component is destroy, or it will call the callback function multiple times
        // rateSocket.on("rate_request_result", this.onQuoteResult);

        this.getAccesorialConfig();
        if (this.myAccountData.billing.locationId) {
            this.getProducts();
        }
    }

    beforeDestroy() {
        // if (!this.keepQuote && this.quoteData.quoteId) {
        //   this.deleteQuote();
        // }
        // remove listener
        // rateSocket.removeListener("rate_request_result", this.onQuoteResult);
    }
    // end of life cycle methods

    // methods
    addLine() {
        this.$store.dispatch('addLine');
    }

    goEdit() {
        // this.getQuote(this.quoteData.quoteId);
        // window.location.href = "getquote?isEdit=true&quoteNumber=3594392";
        this.quoteData.hasQuote = false;
        this.isEditMode = true;
    }

    goToSavedQuotesPage() {
        console.log('gotosavedpage');
        window.location.href = '#/savedQuote';
    }

    get palletOverValue() {
        let overValue: boolean = false;

        this.quoteData.pallets.forEach((item: any) => {
            console.log(parseInt(item.quantity) + ', ' + parseInt(item.totalWeight));
            if (parseInt(item.quantity) > 15 || parseInt(item.totalWeight) > 1800) {
                overValue = true;
            }
        });

        if (this.quoteData.hasHazardous) {
            overValue = true;
        }

        return overValue;
    }

    async validate() {
        console.log('type:::', this.quoteData.shipperType);
        this.validationStarted = true;

        let result = await this.$validator.validateAll();

        if (this.overWeight || this.exceedPalletSpaces || this.quoteData.hasHazardous) {
            this.$modal.show(this.palletOverValueModal);
            return;
        }

        if (result && !this.overWeight && !this.exceedPalletSpaces) {
            console.log('backend submit');
            this.backendSubmit();
        } else {
            console.log('validate failed', result, this.overWeight, this.exceedPalletSpaces);
        }
    }

    submit() {
        if (this.isEditMode) {
            this.$modal.show(this.editQuoteModal);
        } else {
            this.validate();
        }
    }

    async pickupZipAutoComplete() {
        let pickupZipAutoComplete = new googleAutoComplete('input_zip_code_pickup');
        pickupZipAutoComplete.setShortStateName();

        while (true) {
            let result: any = await pickupZipAutoComplete.searchResult();

            this.quoteData.pickup.zipCode = result.postal_code;
            this.quoteData.pickup.city = result.city;
            this.quoteData.pickup.state = result.state;
        }
    }

    async deliveryZipAutoComplete() {
        let pickupZipAutoComplete = new googleAutoComplete('input_zip_code_delivery');
        pickupZipAutoComplete.setShortStateName();

        while (true) {
            let result: any = await pickupZipAutoComplete.searchResult();

            this.quoteData.delivery.zipCode = result.postal_code;
            this.quoteData.delivery.city = result.city;
            this.quoteData.delivery.state = result.state;
        }
    }

    async getAccesorialConfig() {
        try {
            let response = await tmsService.post('write_new/get_tms_acc_name_v2.php');
            this.accessorialData = response.data;
        } catch (error) {
            console.log(error.message);
        }
    }

    async saveQuote() {
        this.keepQuote = true;
        this.savedQuote(
            (res: any) => {
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Success!';
                messageModel['titleColor'] = '#15223d';
                messageModel['messageModelMessage'] =
                    'Your quote has been saved as #' + res['quote_id'];
                messageModel['waitMillsSecondsToClose'] = 3000;
                messageModel['clickToClose'] = true;
                this.$store.dispatch('updateMessageModel', messageModel);
                window.location.href = '#/savedQuote'; // redirect
            },
            (error: any) => {
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Error';
                messageModel['titleColor'] = '#15223d';
                messageModel['clickToClose'] = true;
                messageModel['messageModelMessage'] =
                    'We were unable to save your quote at this time. Please, try again later.';
                messageModel['waitMillsSecondsToClose'] = 3000;
                this.$store.dispatch('updateMessageModel', messageModel);
            }
        );
    }

    async schedulePickup() {
        this.getCreditLimit();
    }

    async getCreditLimitV2(bill_to: any) {
        try {
            let response = await clientService.post('write/get_credit_limit_balance.php', bill_to);
            this.creditLimit = response.data;

            if (this.creditLimit == -1) {
                this.$modal.show(this.errorOverCreditModal);
            } else if (this.creditLimit == -2) {
                this.$modal.show(this.errorNoCreditModal);
            } else if (this.creditLimit == 1) {
                this.$modal.show(this.schedulePickupModal);

                this.keepQuote = true;
                this.savedQuote();
                this.$store.dispatch('changeQuotePageStage', 'schedulePage');
                window.location.href = '#/schedulepickup';
            }
        } catch (error) {
            console.log(error.message);
        }

        console.log('response: ' + this.creditLimit);
    }

    async getCreditLimit() {
        try {
            let bill_to = {
                billto_id: this.myAccountData.billing.locationId,
                current_amount: this.quoteData.estimate.total,
            };
            let response = await clientService.post('write/get_credit_limit_balance.php', bill_to);
            this.creditLimit = response.data;

            if (this.creditLimit == -1) {
                this.$modal.show(this.errorOverCreditModal);
            } else if (this.creditLimit == -2) {
                this.$modal.show(this.errorNoCreditModal);
            } else if (this.creditLimit == 1) {
                this.keepQuote = true;
                this.savedQuote();
                this.$store.dispatch('changeQuotePageStage', 'schedulePage');
                window.location.href = '#/schedulepickup';
            }
        } catch (error) {
            console.log(error.message);
        }

        console.log('response: ' + this.creditLimit);
    }

    async deleteQuote() {
        try {
            let response = await tmsService.post('write_new/write_tms_quote_decline.php', {
                quote_id: this.quoteData.quoteId,
            });
        } catch (error) {
            console.log(error.message);
        }
    }
    // end of methods

    // Modal
    cancelQuoteModal: string = 'cancelQuoteModal';
    cancelQuoteRightBtnAction() {
        window.location.href = '#/home';
    }
    cancelQuoteLeftBtnAction() {
        this.$modal.hide(this.cancelQuoteModal);
    }

    cancel() {
        if (this.isEditMode) {
            this.$modal.show(this.cancelSavedQuoteModal);
        } else {
            this.$modal.show(this.cancelQuoteModal);
        }
    }

    closeModal() {
        this.$modal.hide(this.cancelQuoteModal);
    }

    confirmModal() {
        window.location.href = '#/home';
    }
    // end of Modal

    // Error Modal
    noDataModal: string = 'noDataModal';
    noDataModalTitle: string = 'Calculation Failed';
    noDataModalMessage: string = 'Please modify your input and try again.';
    closeNoDataModal() {
        this.$modal.hide(this.noDataModal);
    }
    // end of Error Modal

    // schedulePickup Redirect Modal
    schedulePickupModal: string = 'schedulePickupModal';
    schedulePickupTitle: string = 'Auto Redirect';
    schedulePickupSuccessModalMessage: string = 'Getting you there. Hang on tight.';
    closeScheduleModal() {
        this.$modal.hide(this.schedulePickupModal);
    }

    // Error Modal
    errorModal: string = 'errorModal';
    errorModalTitle: string = 'Error';
    closeErrorModal() {
        this.$modal.hide(this.errorModal);
    }
    // end of Error Modal

    cancelSavedQuoteModal: string = 'cancelSavedQuoteModal';
    cancelSavedQuoteRightBtnAction() {
        window.location.href = '#/savedquote';
    }
    cancelSavedQuoteLeftBtnAction() {
        this.$modal.hide(this.cancelSavedQuoteModal);
    }

    palletOverValueModal: string = 'palletOverValueModal';
    palletOverValueModalRightBtnAction() {
        window.location.href = 'index.html#/home';
    }
    palletOverValueModalRightBtnStyle: any = {
        display: 'none !important',
    };

    editQuoteModal: string = 'editQuoteModal';
    editQuoteModalRightBtnStyle: any = {
        'background-color': '#15223d !important',
    };
    editQuoteModalRightBtnAction() {
        this.$modal.hide(this.editQuoteModal);
        this.validate();
    }
    editQuoteModalLeftBtnAction() {
        this.$modal.hide(this.editQuoteModal);
    }

    updateAdditionalServices(code: any, name: any, event: any) {
        if (event.target.checked) {
            this.quoteData.additionalServices.push({ code: code, name: name });
            this.additionalServiceCodeList.push(code);
        } else {
            let _this = this;
            this.quoteData.additionalServices.forEach((item: any, index: number) => {
                if (item.code == code) {
                    _this.quoteData.additionalServices.splice(index, 1);
                }
            });
            if (this.additionalServiceCodeList.indexOf(code) !== -1) {
                let index = this.additionalServiceCodeList.indexOf(code);
                this.additionalServiceCodeList.splice(index, 1);
            }
        }
    }

    // message modal
    successModalName: string = 'successModal';
    successModalTitle: string = 'Success';
    successModalMessage: string = 'Successfully Saved';

    async getQuote(quoteId: number | string) {
        let url = 'write_new/get_tms_quote_line.php';

        let request = {
            input_search_quote_id: null,
            input_search_date_from: '',
            input_search_date_to: '',
            billto_id: this.myAccountData.billing.locationId,
            quote_id: quoteId,
            input_search_shipper_state: '',
            input_search_shipper_zip: null,
            input_search_consignee_state: '',
            input_search_consignee_zip: null,
            input_search_status: 0,
            input_search_limit: 1,
            quote: 0,
            pageName: 'dashboardQuote',
        };

        let result = await tmsService.post(url, request);

        let mapper = new QuoteMapper(result.data);
        mapper.fillResult(this.quoteData);
        this.updateAdditionalServiceCodeList(result);
    }

    updateAdditionalServiceCodeList(result: any) {
        if (Array.isArray(result.data.m_lines)) {
            result.data.m_lines.forEach((item: any) => {
                if (item.shipment_code && this.accArray.indexOf(item.shipment_code) !== -1) {
                    this.additionalServiceCodeList.push(item.shipment_code);
                    this.quoteData.additionalServices.push({
                        code: item.shipment_code,
                        name: item.shipment_content,
                    });
                }
            });
        }
    }

    async savedQuote(resolve?: any, reject?: any) {
        let url = 'write_new/write_update_quote_status.php';
        let json3 = {
            quote_id: this.quoteData.quoteId,
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };

        tmsService
            .post(url, qs.stringify(json3))
            .then(res => {
                if (resolve) {
                    Object.assign(res, json3);
                    resolve(res);
                }
                console.log(res);
            })
            .catch(error => {
                if (reject) {
                    reject(error);
                }
                console.log(error);
            });
    }

    onQuoteResult(data: any) {
        this.calculating = false;

        let json = data;
        if (json.quote_id > 0 && parseFloat(json.quote_amount) > 0) {
            this.quoteData.hasQuote = true;
            this.quoteData.quoteId = json.quote_id;

            let analyzer = new QuoteResultAnalyzer(json);

            analyzer.analyze();
            analyzer.mapEstimate(this.quoteData.estimate);

            // setTimeout(() => {
            //   VueScrollTo.scrollTo("#estimatedQuoteBox", 1000);
            // }, 100);
            // denying a quote in TMS, reactivate it again if user click save
            // if (!this.keepQuote) {
            //   this.deleteQuote();
            // }
        } else {
            this.$modal.show(this.palletOverValueModal);
        }
    }

    getSelectedWarehouse(warehouseId: number) {
        let selectedWarehouse = {};
        this.warehouseList.forEach((warehouse: any) => {
            if (warehouse.location_id === warehouseId) {
                selectedWarehouse = warehouse;
            }
        });
        return selectedWarehouse;
    }

    onWarehouseChange() {
        let warehouse: any = this.getSelectedWarehouse(this.currentWarehouseId);
        this.quoteData.pickup.city = warehouse.location_city;
        this.quoteData.pickup.state = warehouse.location_state;
        this.quoteData.pickup.zipCode = warehouse.location_zip;
    }

    backendSubmit() {
        // proceed only when accessorial data is available
        if (this.accessorialData.length > 0 && this.myAccountData.billing.locationId) {
            this.calculating = true;
            this.quoteData.billto_id = this.myAccountData.billing.locationId;
            this.quoteData.shipper_id = this.myAccountData.shipping.locationId;
            // scroll to top
            document.body.scrollTop = document.documentElement.scrollTop = 0;

            let requestData = new QuoteRequestBuilder(
                this.quoteData,
                this.accessorialData,
                this.tmsAccList
            ).getRequestData();
            console.log('requestData', requestData);
            let _this = this;
            tmsServiceBackend
                .post('quote/tmsMileService', qs.stringify(requestData))
                .then(function(response) {
                    const result = response.data;
                    if (result.status != 0) {
                        _this.onQuoteResult(result.data);
                    } else {
                        let messageModel = {};
                        messageModel['isShowMessageModel'] = true;
                        messageModel['messageModelTitle'] = 'Error';
                        messageModel['titleColor'] = '#15223d';
                        messageModel['clickToClose'] = true;
                        messageModel['messageModelMessage'] = result.message;
                        messageModel['waitMillsSecondsToClose'] = 3000;
                        _this.$store.dispatch('updateMessageModel', messageModel);
                    }
                    _this.calculating = false;
                })
                .catch(function(error) {
                    _this.calculating = false;
                    console.log(error);
                });
        } else {
            this.$modal.show(this.errorModal);
        }
    }

    @Watch('myAccountData.billing.locationId')
    onBiilToIdChange(val: string, oldVal: string, event: any) {
        if (parseInt(val) != 0 && parseInt(val) != NaN) {
            this.getProducts();
        }
    }
    getProducts() {
        tmsServiceBackend
            .post(
                'product/getProducts',
                qs.stringify({ bill_to: this.myAccountData.billing.locationId })
            )
            .then(response => {
                const result = response.data;
                if (result.status == 1) {
                    this.productList = result.data;
                }
            })
            .catch(error => {});
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/getQuoteUnis100/index.ts